import { useId } from "@fluentui/react-components";
import { useStyles } from "./WorkspacePageHeader.styles";
import { IWorkspacePageHeaderProps } from "./WorkspacePageHeader.types";

export const WorkspacePageHeader = ({
  title,
  action,
}: IWorkspacePageHeaderProps): JSX.Element => {
  const styles = useStyles();
  const titleId = useId("workspace-page-title-");

  return (
    <header className={styles.root} aria-labelledby={titleId}>
      <div className={styles.textBlock}>
        <h1 id={titleId} className={styles.title} title={title}>
          {title}
        </h1>
      </div>
      {action && <div className={styles.action}>{action}</div>}
    </header>
  );
};
